import React from 'react';
import moment from 'moment';
import NoDataMsg from 'library/noData';

const Body = (props) => (

    <div>
        {
            !props.restockbyCaps || props.restockbyCaps.list.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div>
                    <div className="row m-0">
                    </div>
                    <div className="table-responsive">
                        {
                            props.restockbyCaps.list.map((item, index) => {
                                return (
                                    <div className="row m-0 mb-2  text-center" style={{ borderStyle: 'Solid', borderBottomWidth: '1px', borderTopWidth: '0px', borderLeftmWidth: '0px', borderRightWidth: '0px' }} key={index} >
                                        <div className="row m-0 mb-2">
                                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-center">
                                                <label>Product Name</label>
                                                <h3 className="m-0 grey-text">{item.name}</h3>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-center">
                                                <label>SKU</label>
                                                <h3 className="m-0 grey-text">{item.sku}</h3>
                                                <label>Category</label>
                                                <h3 className="m-0 grey-text">{item.category}</h3>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-center">
                                                <label>Brand</label>
                                                <h3 className="m-0 grey-text">{item.brand}</h3>
                                                <label>Species</label>
                                                <h3 className="m-0 grey-text">{item.species}</h3>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-center">
                                                <label>Current Inventory</label>
                                                <h3 className="m-0 grey-text">{item.currentInventory} Units</h3>
                                                <label>Restock Caps</label>
                                                <h3 className="m-0 grey-text">{item.restockCap} Units</h3>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                    </div>
                </div>
        }
    </div>
);

export default Body;